import * as moment from "moment";
import { CommonConstants } from "../../global/interfaces";

export const pdfStyle = {
  title: {
    font: "GeorgiaPro",
    color: "#000f47",
    fontSize: 34,
    characterSpacing: 2,
    alignment: "left",
    margin: [0, 10, 0, 0],
  },
  subtitle: {
    color: "#000f47",
    fontSize: 11,
    alignment: "left",
    margin: [0, 20, 0, 0],
  },
  subsubtitle: {
    color: "#808080",
    fontSize: 11,
    alignment: "left",
    margin: [0, 0, 0, 0],
  },
  subtitleDate: {
    color: "#000f47",
    fontSize: 11,
    alignment: "left",
    margin: [0, 0, 0, 20],
  },
  chartTitleNew: {
    color: "#000f47",
    fontSize: 11,
    alignment: "left",
    margin: [0, 0, 0, 0],
  },
  subChartTitleNew: {
    color: "#000f47",
    fontSize: 11,
    alignment: "left",
    margin: [0, 0, 0, 15],
  },
  header: {
    color: "#000f47",
    bold: true,
    fontSize: 8,
    alignment: "left",
    margin: [40, 20, 0, 0],
  },
  subheader: {
    color: "#00a8c8",
    bold: true,
    fontSize: 8,
    alignment: "left",
    margin: [40, 0, 0, 0],
  },
  tableCaption: {
    color: "#404040",
    bold: true,
    fontSize: 11,
    margin: [0, 0, 0, 10],
  },
  tableHeader: {
    fillColor: "#000f47",
    color: "#FFF",
    fontSize: 11,
    bold: true,
  },
  tableHeaderNZ: {
    fillColor: "#000f47",
    color: "#FFF",
    fontSize: 10,
    bold: true,
  },
  tableHeaderSI: {
    fillColor: "#000f47",
    color: "#FFF",
    fontSize: 9,
    bold: true,
  },
  tableHeaderTaxDetails: {
    fillColor: "#000f47",
    color: "#FFF",
    fontSize: 8,
    bold: true,
  },
  textCell: {
    fillColor: "#F0F0F0",
    color: "#000f47",
    fontSize: 11,
    margin: [1, 1, 1, 1],
  },
  textCellNZ: {
    fillColor: "#F0F0F0",
    color: "#000f47",
    fontSize: 9,
    // margin: [1, 1, 1, 1]
    margin: [0, 0, 0, 0],
  },
  textCellSI: {
    fillColor: "#F0F0F0",
    color: "#000f47",
    fontSize: 9,
    margin: [1, 1, 1, 1],
  },
  totalPortfolioText: {
    fillColor: "#017FB3",
    color: "#FFF",
    fontSize: 11,
    margin: [1, 1, 1, 1],
  },
  totalPortfolioNumber: {
    fillColor: "#017FB3",
    color: "#FFF",
    alignment: "center",
    fontSize: 11,
    margin: [1, 1, 1, 1],
  },
  totalPortfolioBenchmarkText: {
    fillColor: "#01AFD2",
    color: "#FFF",
    bold: true,
    fontSize: 11,
    margin: [1, 1, 1, 1],
  },
  totalPortfolioBenchmarkNumber: {
    fillColor: "#01AFD2",
    color: "#FFF",
    bold: true,
    alignment: "center",
    fontSize: 11,
    margin: [1, 1, 1, 1],
  },
  numberCell: {
    fillColor: "#F0F0F0",
    color: "#000f47",
    alignment: "center",
    fontSize: 11,
    margin: [1, 1, 1, 1],
  },
  numberCellNZ: {
    fillColor: "#F0F0F0",
    color: "#000f47",
    alignment: "center",
    fontSize: 9,
    // margin: [1, 1, 1, 1]
    margin: [0, 0, 0, 0],
  },
  numberCellSI: {
    fillColor: "#F0F0F0",
    color: "#000f47",
    alignment: "center",
    fontSize: 9,
    margin: [1, 1, 1, 1],
  },
  numberCellTaxDetails: {
    fillColor: "#F0F0F0",
    color: "#000f47",
    alignment: "center",
    fontSize: 9,
    margin: [1, 1, 1, 1],
    bold: true,
  },
  notesTitle: {
    font: "GeorgiaPro",
    color: "#000f47",
    bold: true,
    fontSize: 24,
    margin: [0, 0, 0, 10],
  },
  notesPieTax: {
    color: "#000f47",
    fontSize: 11,
    margin: [0, 10, 0, 5],
  },
  notes: {
    color: "#000f47",
    fontSize: 11,
    margin: [0, 0, 0, 5],
  },
  notesData: {
    fontSize: 11,
  },
  fundContactTitle: {
    color: "#000f47",
    fontSize: 11,
    bold: true,
    margin: [0, 40, 0, 10],
  },
  PirAndPieTitle: {
    color: "#000f47",
    fontSize: 11,
    bold: true,
    margin: [0, 0, 0, 0],
  },
  PirAndPieDate: {
    color: "#000f47",
    fontSize: 11,
    // alignment: 'left',
    margin: [0, 0, 0, 0],
  },
  PirValue: {
    color: "#000f47",
    fontSize: 11,
    // alignment: 'left',
    margin: [0, 0, 0, 15],
  },
  noticeTitle: {
    font: "GeorgiaPro",
    color: "#000f47",
    bold: true,
    fontSize: 24,
    margin: [0, 0, 0, 15],
  },
  noticeData: {
    fontSize: 11,
  },
  fundContactPhone: {
    fontSize: 11,
    margin: [0, 0, 0, 10],
  },
  fundContactEmail: {
    fontSize: 11,
    margin: [0, 0, 0, 10],
  },
  fundContactWebsite: {
    fontSize: 11,
    margin: [0, 0, 0, 10],
  },
  consultantName: {
    color: "#000f47",
    fontSize: 11,
    bold: true,
    margin: [0, 20, 0, 10],
  },
  consultantPhone: {
    fontSize: 11,
    margin: [0, 0, 0, 10],
  },
  consultantMail: {
    fontSize: 11,
    margin: [0, 0, 0, 10],
  },
  clientTitle: {
    margin: [0, 20, 0, 10],
    color: "#000f47",
    fontSize: 14,
    bold: true,
  },
  clientAddress: {
    color: "#000f47",
    fontSize: 11,
  },
  clientWebsite: {
    color: "#000f47",
    fontSize: 11,
  },
  Esgfootnote: {
    fontSize: 9,
    margin: [0, 0, 0, 0],
  },
};
export function pdfFooter(currentPage, totalPages, payload, mmcLogo) {
  if (currentPage === 1) {
    return {};
  } else if (currentPage === totalPages) {
    return [
      {
        columns: [
          {
            text: `${payload.client}`,
            alignment: "left",
            color: "#000f47",
            margin: [40, 40, 0, 0],
          },
          {
            text:
              "Date Generated: " +
              moment().format(CommonConstants.displayDateFormatInAU),
            alignment: "right",
            color: "#000f47",
            margin: [40, 40, 40, 0],
          },
        ],
      },
    ];
  } else {
    return [
      {
        columns: [
          {
            text: `${payload.client}`,
            alignment: "left",
            color: "#000f47",
            margin: [40, 40, 0, 0],
          },
          {
            text:
              "Date Generated: " +
              moment().format(CommonConstants.displayDateFormatInAU),
            alignment: "right",
            color: "#000f47",
            margin: [40, 40, 40, 0],
          },
        ],
      },
    ];
  }
}

export function pdfHeader(mmcLogo, reportType, currentPage, totalPages) {
  if (currentPage === 1) {
    return [
      {
        columns: [
          {
            image: mmcLogo,
            alignment: "left",
            width: 140,
            margin: [40, 40, 0, 0],
          }
        ],
      },
    ];
  } else if (currentPage === totalPages) {
    return {
      text: `${reportType}`,
      color: "#868D95",
      margin: [40, 40, 0, 15],
      bold: true,
    };
  } else {
    return {
      text: `${reportType}`,
      color: "#868D95",
      margin: [40, 40, 0, 15],
      bold: true,
    };
  }
}
export function pdfFooterNZ(currentPage, totalPages, payload, mmcLogo) {
  if (currentPage === 1) {
    return {};
  } else if (currentPage === totalPages) {
    return [
      {
        columns: [
          {
            text: `${payload.client}`,
            alignment: "left",
            color: "#000f47",
            margin: [19, 40, 0, 0],
          },
          {
            text:
              "Date Generated: " +
              moment().format(CommonConstants.displayDateFormatInAU),
            alignment: "right",
            color: "#000f47",
            margin: [40, 40, 40, 0],
          },
        ],
      },
    ];
  } else {
    return [
      {
        columns: [
          {
            text: `${payload.client}`,
            alignment: "left",
            color: "#000f47",
            margin: [19, 40, 0, 0],
          },
          {
            text:
              "Date Generated: " +
              moment().format(CommonConstants.displayDateFormatInAU),
            alignment: "right",
            color: "#000f47",
            margin: [40, 40, 40, 0],
          },
        ],
      },
    ];
  }
}

export function pdfHeaderNZ(mmcLogo, reportType, currentPage, totalPages) {
  if (currentPage === 1) {
    return [
      {
        columns: [
          {
            image: mmcLogo,
            alignment: "left",
            width: 140,
            margin: [19, 40, 0, 0],
          }
        ],
      },
    ];
  } else if (currentPage === totalPages) {
    return {
      text: `${reportType}`,
      color: "#868D95",
      margin: [19, 40, 0, 15],
      bold: true,
    };
  } else {
    return {
      text: `${reportType}`,
      color: "#868D95",
      margin: [19, 40, 0, 15],
      bold: true,
    };
  }
}
